<template>
  <div class="h-screen bg-primary-500 shadow-inner text-white  p-5 overflow-y-auto w-24 transparent-white-scroll border-r-2 border-primary-500">
    <div>
      <a href="/">
        <img :src="orgSettings.logoUrl" :alt="orgSettings.name">
      </a>
    </div>
    <ul class="pt-24 text-center items-center justify-center">
      <template v-for="item in navItems">
        <li v-if="userHasAccess(item)" :key="item.path" class="mb-2 flex justify-center">
          <router-link v-if="!item.hideFromNav" v-slot="{ href, isActive }" :to="item.path" custom>
            <div class="rounded-full h-12 w-12 p-5 flex items-center justify-center" :class="{'bg-secondary-500 ': isActive}">
              <a :href="href" class="no-underline">
                <div class="flex items-center text-left py-5">
                  <d-icon class="px-3 " size="lg" :icon="item.iconName" />
                </div>
              </a>
            </div>
          </router-link>
        </li>
      </template>
    </ul>
  </div>
</template>

<script>
  import { routes } from '../routing/index';
  import { useAuthStore } from '@stores/auth';

  export default {
    parent: true,

    data() {
      return {
        navItems: routes,
      };
    },
    props: {
        orgSettings: {
            type: Object,
            default: () => null,
        },
    },
    methods: {
      userHasAccess(item) {
        if (item.roles) {
          const authStore = useAuthStore();
          return authStore.hasAnyRole(item.roles);
        }

        return true;
      },
    },
  };
</script>